// PrivacyPolicy.jsx
import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg my-10">
            <h1 className="text-3xl font-bold mb-6 text-center text-gray-800">Privacy Policy</h1>
            <p className="text-gray-700 mb-4">
                This privacy policy sets out how Parinay Setu uses and protects any information that you give
                Parinay Setu when you visit their website and/or agree to purchase from them.
            </p>
            <p className="text-gray-700 mb-4">
                Parinay Setu is committed to ensuring that your privacy is protected. Should we ask you to
                provide certain information by which you can be identified when using this website, you can be assured that
                it will only be used in accordance with this privacy statement.
            </p>
            <p className="text-gray-700 mb-4">
                Parinay Setu may change this policy from time to time by updating this page. You should check
                this page periodically to ensure that you adhere to these changes.
            </p>
            <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">Information We May Collect</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Name</li>
                <li>Contact information including email address</li>
                <li>Demographic information such as postcode, preferences, and interests, if required</li>
                <li>Other information relevant to customer surveys and/or offers</li>
            </ul>
            <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">What We Do with the Information We Gather</h2>
            <p className="text-gray-700 mb-4">
                We require this information to understand your needs and provide you with a better service, and in
                particular for the following reasons:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Internal record keeping.</li>
                <li>Improving our products and services.</li>
                <li>
                    Sending promotional emails about new products, special offers, or other information which we think you
                    may find interesting using the email address which you have provided.
                </li>
                <li>
                    Contacting you for market research purposes. We may contact you by email, phone, fax, or mail.
                </li>
                <li>Customizing the website according to your interests.</li>
            </ul>
            <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">How We Use Cookies</h2>
            <p className="text-gray-700 mb-4">
                A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree,
                the file is added and the cookie helps analyze web traffic or lets you know when you visit a particular site.
                Cookies allow web applications to respond to you as an individual, tailoring operations to your needs.
            </p>
            <p className="text-gray-700 mb-4">
                We use traffic log cookies to identify which pages are being used. This helps us analyze webpage traffic
                data to improve our website based on customer needs. We only use this information for statistical analysis
                purposes.
            </p>
            <p className="text-gray-700 mb-4">
                Overall, cookies help us provide a better website by enabling us to monitor which pages you find useful and
                which you do not. A cookie does not give us access to your computer or any personal information, other
                than the data you choose to share with us.
            </p>
            <p className="text-gray-700 mb-4">
                You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can
                usually modify your browser settings to decline cookies. This may prevent you from taking full advantage of
                the website.
            </p>
            <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">Controlling Your Personal Information</h2>
            <p className="text-gray-700 mb-4">
                You may choose to restrict the collection or use of your personal information in the following ways:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>
                    Whenever you are asked to fill in a form on the website, look for the checkbox that you can click to indicate
                    that you do not want the information to be used for direct marketing purposes.
                </li>
                <li>
                    If you have previously agreed to us using your personal information for direct marketing, you may change
                    your mind at any time by writing to or emailing us at parinaysetu17@gmail.com.
                </li>
            </ul>
            <p className="text-gray-700 mt-4">
                If you believe any information we hold about you is incorrect or incomplete, please contact us at:
            </p>
            <ul className="list-disc list-inside mt-2 text-gray-700">
                <li>Address: C11 Vinay Nagar Sector 3, Behind Power House, Gwalior, Madhya Pradesh, 474012</li>
                <li>Phone: 9479425710</li>
                <li>Email: parinaysetu2701@gmail.com</li>
            </ul>
        </div>
    );
};

export default PrivacyPolicy;
